<template>
  <div>
    <a-card class="operate-in-head sx-full-height" :bordered="false">
      <a-tabs
				defaultActiveKey="0"
				v-model="currentPaneKey"
				@change="tabsCallback">
        <a-tab-pane tab="待审核信息" key="0">
					<!-- <a-form :form="form0">
						<a-row :gutter="12">
							<a-col :span="3">
								<a-form-item>
									<a-select v-decorator="['signupId']" size="large" style="width: 100%" placeholder="请选择报名">
										<a-select-option v-for="item of signupList" :value="item.id">{{item.title}}</a-select-option>
									</a-select>
								</a-form-item>
							</a-col>
							<a-col :span="3">
								<a-form-item>
									<a-select v-decorator="['studentHouseType']" size="large" style="width: 100%" placeholder="请选择分类" @change="onChangeStudentHouseType">
										<a-select-option :value="0">全部</a-select-option>
										<a-select-option :value="1">生态移民</a-select-option>
										<a-select-option :value="2">城市居民</a-select-option>
									</a-select>
								</a-form-item>
							</a-col>
							<a-col :span="5">
								<a-range-picker
								v-decorator="['reserveRangeValue']"
								size="large"
								style="width: 100%"
								:placeholder="['开始时间', '结束时间'] "></a-range-picker>
							</a-col>
							<a-col :span="7">
								<a-form-item>
									<a-input v-decorator="['searchName']" size="large" style="width: 100%" placeholder="姓名/报名号/身份证号码搜索" />
								</a-form-item>
							</a-col>
							<a-col :span="3">
								<a-button size="large" type="primary" icon="search" @click="onClickSearch">搜 索</a-button>
							</a-col>
							<a-col :span="3" style="text-align: right;">
								<a-button size="large" type="primary" icon="download" style="background: #6eb864; border-color: #6eb864;">导出数据</a-button>
							</a-col>
						</a-row>
					</a-form> -->
				</a-tab-pane>
        <a-tab-pane tab="待定信息" key="1">
					<!-- <a-form :form="form1">
						<a-row :gutter="12">
							<a-col :span="3">
								<a-form-item>
									<a-select v-decorator="['signupId']" size="large" style="width: 100%" placeholder="请选择报名">
										<a-select-option v-for="item of signupList" :value="item.id">{{item.title}}</a-select-option>
									</a-select>
								</a-form-item>
							</a-col>
							<a-col :span="3">
								<a-form-item>
									<a-select v-decorator="['studentHouseType']" size="large" style="width: 100%" placeholder="请选择分类" @change="onChangeStudentHouseType">
										<a-select-option :value="0">全部</a-select-option>
										<a-select-option :value="1">生态移民</a-select-option>
										<a-select-option :value="2">城市居民</a-select-option>
									</a-select>
								</a-form-item>
							</a-col>
							<a-col :span="5">
								<a-range-picker
								v-decorator="['reserveRangeValue']"
								size="large"
								style="width: 100%"
								:placeholder="['开始时间', '结束时间'] "></a-range-picker>
							</a-col>
							<a-col :span="7">
								<a-form-item>
									<a-input v-decorator="['searchName']" size="large" style="width: 100%" placeholder="姓名/报名号/身份证号码搜索" />
								</a-form-item>
							</a-col>
							<a-col :span="3">
								<a-button size="large" type="primary" icon="search" @click="onClickSearch">搜 索</a-button>
							</a-col>
							<a-col :span="3" style="text-align: right;">
								<a-button size="large" type="primary" icon="download" style="background: #6eb864; border-color: #6eb864;">导出数据</a-button>
							</a-col>
						</a-row>
					</a-form> -->
				</a-tab-pane>
        <a-tab-pane tab="审核不通过信息" key="3">
					<!-- <a-form :form="form2">
						<a-row :gutter="12">
							<a-col :span="4">
								<a-form-item>
									<a-select v-decorator="['signupId']" size="large" style="width: 100%" placeholder="请选择报名">
										<a-select-option v-for="item of signupList" :value="item.id">{{item.title}}</a-select-option>
									</a-select>
								</a-form-item>
							</a-col>
							<a-col :span="4">
								<a-form-item>
									<a-select v-decorator="['studentHouseType']" size="large" style="width: 100%" placeholder="请选择分类" @change="onChangeStudentHouseType">
										<a-select-option :value="0">全部</a-select-option>
										<a-select-option :value="1">生态移民</a-select-option>
										<a-select-option :value="2">城市居民</a-select-option>
									</a-select>
								</a-form-item>
							</a-col>
							<a-col :span="7">
								<a-form-item>
									<a-input v-decorator="['searchName']" size="large" style="width: 100%" placeholder="姓名/报名号/身份证号码搜索" />
								</a-form-item>
							</a-col>
							<a-col :span="3">
								<a-button size="large" type="primary" icon="search" @click="onClickSearch">搜 索</a-button>
							</a-col>
							<a-col :span="6" style="text-align: right;">
								<a-button size="large" type="primary" icon="download" style="background: #6eb864; border-color: #6eb864;">导出数据</a-button>
							</a-col>
						</a-row>
					</a-form> -->
				</a-tab-pane>
        <a-tab-pane tab="审核通过信息" key="2">
				</a-tab-pane>
      </a-tabs>

			<a-form :form="form">
				<a-row :gutter="12">
					<a-col :span="6">
						<a-form-item>
							<a-select
							v-decorator="['signupId']"
							size="large"
							style="width: 100%"
							placeholder="请选择报名">
								<a-select-option
									v-for="(item, index) of signupList"
									:key="index"
									:value="item.signupNoticeId">{{item.title}}</a-select-option>
							</a-select>
						</a-form-item>
					</a-col>
					<a-col :span="4" v-show="this.villageList.length">
            <a-form-item>
              <a-select allowClear v-decorator="['villageCode']" size="large" style="width: 100%" placeholder="请选择社区">
                <!-- <a-select-option :value="0">全部社区</a-select-option> -->
                <a-select-option v-for="item of villageList" :value="item.code">{{item.name}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

					<a-col :span="4" v-if="studentType == 2">
						<a-form-item>
							<a-select
								v-decorator="['grade']" size="large" style="width: 100%" placeholder="请选择年级" @change="onChangeGrade">
								<a-select-option :value="0">全部年级</a-select-option>
								<a-select-option
									v-for="(item, index) of gradeList"
									:key="index"
									:value="item">{{item}}</a-select-option>
							</a-select>
						</a-form-item>
					</a-col>
					<a-col :span="4" v-if="adminLevel !== 'school'">
						<a-form-item>
							<a-select allowClear v-decorator="['containArea']" size="large" style="width: 100%" placeholder="原就读学校" @change="onChangeGrade">
								<a-select-option :value="0">区内</a-select-option>
								<a-select-option :value="1">区外</a-select-option>
							</a-select>
						</a-form-item>
					</a-col>

					<a-col :span="4" v-if="adminLevel !== 'school'">
						<a-form-item>
							<a-select allowClear v-decorator="['applyType']" size="large" style="width: 100%" placeholder="办理类型" @change="onChangeGrade">
								<a-select-option :value="1">材料办理</a-select-option>
								<a-select-option :value="2">积分办理</a-select-option>
							</a-select>
						</a-form-item>
					</a-col>
        </a-row>

        <a-row :gutter="12">
					<a-col :span="6">
						<a-form-item>
							<a-range-picker
							v-decorator="['reserveRangeValue']"
							size="large"
							style="width: 100%"
							:placeholder="['开始时间', '结束时间'] "></a-range-picker>
						</a-form-item>
					</a-col>

					<a-col :span="4">
						<a-form-item>
							<a-input v-decorator="['searchName']" size="large" placeholder="预报名号/姓名/身份证号码" />
						</a-form-item>
					</a-col>

          <a-col :span="3">
            <a-button size="large" type="primary" style="width: 100%" icon="search" @click="onClickSearch">搜 索</a-button>
          </a-col>

					<a-col :span="3">
						<a-button
						@click="handleExportData"
						size="large" type="primary" icon="download" style="width: 100%;background: #6eb864; border-color: #6eb864;">导出数据</a-button>
					</a-col>
				</a-row>
			</a-form>

			<a-table
				ref="aTable"
				v-show="tableData.length"
				:scroll="{x: 1360}"
				@change="handleTableChange"
				:pagination="pagination"
				:columns="filteredColumns"
				:dataSource="tableData"
				rowKey="id"
				:rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}">
        <template slot="actionId" slot-scope="actionId">
          <router-link :to='{path: "/admin/view_info", query: {studentSignupId: actionId,status:getItem(actionId).status}}' target="_blank">
            <a-button
              size="small"
              style="margin:5px; min-width: 60px;">
              查看
            </a-button>
          </router-link>
          <a-button
            v-if="getItem(actionId).status!==2"
            size="small"
            type="danger"
            @click="handleClickActionBtn({action:'delete',text:'删除',studentSignupId: actionId}, actionId)"
            style="margin:5px; min-width: 60px;">
            删除
          </a-button>
          <a-button
            v-for="(item, index) in actionBtns"
            :key="index"
            :type="item.type"
            style="margin:5px; min-width: 60px;"
            size="small"
            @click="handleClickActionBtn(item, actionId)">{{item.text}}
          </a-button>
          <!--<a-button-->
            <!--v-if="currentPaneKey === '2' && studentType !== 1"-->
            <!--type="primary"-->
            <!--size="small"-->
            <!--icon="download"-->
            <!--@click="handleClickSuccessDownBtn(actionId)"-->
            <!--style="margin:5px; min-width: 60px; background: #6eb864; border-color: #6eb864;">-->
            <!--下载报名通知单-->
          <!--</a-button>-->
        </template>
			</a-table>
			<p v-show="tableData.length <= 0"
				class="sx-align-center"
				style="color:#aaa;">暂无数据</p>
    </a-card>
  </div>
</template>

<script>
  import moment from 'moment';
	import AdminCommon from './mixins/admin_common';

  export default {
    mixins: [AdminCommon],
    components: {},
    data() {
      return {
				form: this.$form.createForm(this),

				signupList: [],

				currentPaneKey: '0',

				selectedRowKeys: [],

        tableData: [],

				columns: [{
						title: '分类',
						align: 'center',
						width: 100,
						dataIndex: 'houseTypeName'
					}, {
						title: '预约报名号',
						align: 'center',
						dataIndex: 'id'
					}, {
						title: '预约时间',
						align: 'center',
						width: 140,
						dataIndex: 'orderDateString'
					}, {
						title: '身份证号',
						align: 'center',
						dataIndex: 'idCard'
					}, {
						title: '姓名',
						width: 80,
						align: 'center',
						dataIndex: 'name'
					}, {
						title: '出生日期',
						align: 'center',
						width: 120,
						dataIndex: 'birthday'
					}, {
						title: '性别',
						align: 'center',
						width: 80,
						dataIndex: 'gender'
					}, {
						title: '报名时间',
						width: 120,
						align: 'center',
						dataIndex: 'signupDate'
					}, {
						title: '电话',
						align: 'center',
						dataIndex: 'mobile'
					}, {
						title: '操作',
						width: 215,
						align: 'center',
						dataIndex: 'actionId',
						scopedSlots: { customRender: 'actionId' }
					}],

				pagination: {
					current: 1,
					pageSize: 10,
					total: 0
				}
      };
		},

		computed: {
			// 根据panel显示不同操作按钮
			actionBtns() {
				if (this.currentPaneKey == 0) {
					return [{
						text: '待定',
						action: 'wait',
						status: 1
					}, {
						text: '通过',
						action: 'pass',
						type: 'primary',
						status: 2
					}, {
						text: '不通过',
						action: 'reject',
						type: 'danger',
						status: 3
					}];
				} else if (this.currentPaneKey == 1) {
					return [{
						text: '通过',
						action: 'pass',
						type: 'primary',
						status: 2
					}, {
						text: '不通过',
						action: 'reject',
						type: 'danger',
						status: 3
					}];
				} else if (this.currentPaneKey == 2) {
					return [{
						text: '不通过',
						action: 'reject',
						type: 'danger',
						status: 3
					}];
				} else if (this.currentPaneKey == 3) {
					// 不通过
					return [{
						text: '通过',
						action: 'pass',
						type: 'primary',
						status: 2
					}/*,{
            text: '删除',
            action: 'delete',
            type: 'danger',
            status: 2
          }*/];
				}
			},

			filteredColumns() {
				if (this.studentType === 1) {
					return [{
							title: '预约报名号',
							align: 'center',
							dataIndex: 'id'
						}, {
							title: '预约时间',
							align: 'center',
							width: 140,
							dataIndex: 'orderDateString'
						}, {
							title: '身份证号',
							align: 'center',
							dataIndex: 'idCard'
						}, {
							title: '姓名',
							width: 80,
							align: 'center',
							dataIndex: 'name'
						}, {
							title: '出生日期',
							align: 'center',
							width: 120,
							dataIndex: 'birthday'
						}, {
							title: '性别',
							align: 'center',
							width: 80,
							dataIndex: 'gender'
						}, {
							title: '报名时间',
							width: 120,
							align: 'center',
							dataIndex: 'signupDate'
						}, {
							title: '电话',
							align: 'center',
							dataIndex: 'mobile'
						}, {
							title: '操作',
							width: 215,
							align: 'center',
							dataIndex: 'actionId',
							scopedSlots: { customRender: 'actionId' }
						}];
				} else {
					return [{
						title: '预约报名号',
						align: 'center',
						dataIndex: 'id'
					}, {
						title: '预约时间',
						align: 'center',
						width: 140,
						dataIndex: 'orderDateString'
					}, {
						title: '身份证号',
						align: 'center',
						dataIndex: 'idCard'
					}, {
						title: '姓名',
						width: 80,
						align: 'center',
						dataIndex: 'name'
					}, {
						title: '出生日期',
						align: 'center',
						width: 120,
						dataIndex: 'birthday'
					}, {
						title: '性别',
						align: 'center',
						width: 80,
						dataIndex: 'gender'
					}, {
						title: '报名年级',
						width: 120,
						align: 'center',
						dataIndex: 'orderGradeName'
					}, {
						title: '报名时间',
						width: 120,
						align: 'center',
						dataIndex: 'signupDate'
					}, {
						title: '电话',
						align: 'center',
						dataIndex: 'mobile'
					}, {
						title: '操作',
						width: 215,
						align: 'center',
						dataIndex: 'actionId',
						scopedSlots: { customRender: 'actionId' }
					}];
				}
			}
		},

    created() {
			this.ajaxGetSearchFormData();

			if (this.adminLevel === 'street' && this.streetList.length) {
				this.villageList = this.streetList[0].children || [];
			}
		},

		mounted() {
			this.$nextTick(() => {
				setTimeout(() => {
					document.querySelector('.ant-table-body').style.overflowX = 'auto';
				}, 1000);
			})
		},

    methods: {

      getItem(id){
        for(let item of this.tableData){
          if(id === item.actionId) return item;
        }
        return {status:0};
      },
			// 初始化参数
			initParams() {
				let { status, grade, signupId, containArea, applyType, street, villageCode, time } = this.$route.query;

				// this.currentPaneKey = typeof status !== 'undefined' ? (status + '') : '0';
				this.currentPaneKey = status || '0';

				signupId = signupId || this.signupList[0].signupNoticeId;
				applyType = applyType ? +applyType : undefined;
				containArea = containArea ? +containArea : undefined;

				if (time && time.length) {
					time = time.map(v => moment(v));
				}

				this.form.setFieldsValue({
					grade: grade == 0 ? +grade : grade,
					signupId,
					containArea,
					applyType,
					villageCode
				});
			},

      tabsCallback(key) {
				this.onClickSearch();
      },
      async ajaxGetSearchFormData() {
        let { data } = await this.$ajax.gateway('/bm/ISignupNoticeApi_querySignupNotices', { studentType: this.studentType });

        // 处理获取的报名列表数据
        if (data.code === 200) {
					data = data.data;
					this.signupList = data;
				}

				this.initParams();

				this.$nextTick(() => {
					this.onClickSearch();
				});
      },

      async onClickSearch() {
				this.pagination.current = 1;
				this.search();
      },

			search() {
				let formVal = this.form.getFieldsValue();
				console.log('-> onClickSearch formVal', formVal);
				// formVal.status = parseInt(this.currentPaneKey);
				formVal.status = parseInt(this.currentPaneKey);

				this.fetchStudentSignupPage(formVal);
			},

      onChangeStudentHouseType(value) {
        console.log('-> onChangeStudentHouseType', value);
			},

      onChangeGrade(value) {
        console.log('-> onChangeGrade', value);
			},

			handleTableChange(pagination) {
				console.log('pagination', pagination);
				Object.assign(this.pagination, pagination);
				this.search();
			},

			handleExportData() {
				let formVal = this.form.getFieldsValue();
				formVal.status = parseInt(this.currentPaneKey);

				let params = this.getApiParams(formVal);
				console.log('formVal------', formVal, params);
				this.exportStatisticsSignup(params);
			},

			getApiParams({ school, signupId, street, time, reserveRangeValue, grade, 						containArea, applyType, villageCode, status, searchName }) {
				let signupTime = ['', ''],
					reserveTime = ['', ''];

				if (time) {
					signupTime = time.map(v => v.format('YYYY-MM-DD'));
				}

				if (reserveRangeValue) {
					reserveTime = reserveRangeValue.map(v => v.format('YYYY-MM-DD'));
				}

				school = school || '';
        street = street || '';
				grade = grade || '';

				let ids = [];

				if (this.selectedRowKeys.length) {
					ids = this.selectedRowKeys;
				}

				return {
						reserveBegin: reserveTime[0],
						reserveEnd: reserveTime[1],
            schoolId: school,
            gradeName: grade,
            signupBegin: signupTime[0],
						signupEnd: signupTime[1],
						signupNoticeId: signupId,
						streetCode: street,
						studentType: this.studentType,
						containArea: containArea,
						applyType: applyType,
						villageCode: villageCode || '',
						status,
						keyword: searchName || '',
						ids
				}
			},

			async exportStatisticsSignup({
				reserveBegin,
				reserveEnd,
				schoolId,
				signupBegin,
				signupEnd,
				signupNoticeId,
				streetCode,
				studentType,
				gradeName,
				containArea,
				applyType,
				villageCode,
				keyword,
				status,
				ids
			}) {
				// 报名统计导出 #李茹钰/2019-03-14#
					let { data } = await this.$ajax.gateway('/bm/IStudentSignupApi_exportStatisticsSignupOss', {
					studentType,
					signupNoticeId,
					streetCode,
					schoolId,
					gradeName,
					signupBegin,
					signupEnd,
					reserveBegin,
					reserveEnd,
					containArea,
					applyType,
					villageCode,
					keyword,
					status,
					ids
				});

				if (data && data.code == 200 && data.data.ossFileUrl) {
					window.open(data.data.ossFileUrl, '_blank');
				}
			},

			async fetchStudentSignupPage({ searchName, signupId, status, studentHouseType, grade, reserveRangeValue, villageCode, applyType, containArea }) {
				let reserveBegin = '',
						reserveEnd = '';

				let houseType = studentHouseType && studentHouseType > 0 ? studentHouseType : '';
				status = status !== 'undefined' ? status : '';
				let { current, pageSize } = this.pagination;
				let orderSchoolId = '',
					orderStreetCode = '';

				if (reserveRangeValue && reserveRangeValue.length) {
					reserveBegin = reserveRangeValue[0].format('YYYY-MM-DD'),
					reserveEnd = reserveRangeValue[1].format('YYYY-MM-DD');
				}

				// 报名情况分页查询 #李茹钰/2019-03-13#
				let { data } = await this.$ajax.gateway('/bm/IStudentSignupApi_pageStudentSignup', {
					body: {
						houseType,
						reserveBegin,
						reserveEnd,
						keyword: searchName,
						orderGradeName: grade || '',
						orderSchoolId,
						orderStreetCode,
						orderVillageCode: villageCode,
						pageableDto: {
							page: current,
							size: pageSize,
							sort: 'asc',
							sortProperties: []
						},
						signupNoticeId: signupId,
						status,
						applyType,
						containArea,
						studentType: this.studentType
					}
				});
				if (data.code == 200) {
					data = data.data;

					this.pagination.total = data.totalCount;
					this.tableData = this.formatTableData(data.dataList);
				}
			},

			formatTableData(data) {
				let houseTypeMap = {
					1: '城市居民',
					2: '生态移民'
				};

				return data.map((item, index) => {
						let obj = Object.assign({
							statusString: ['待审核', '待定', '通过', '不通过'][item.status],
							actionId: item.id,
							gender: ['男', '女'][item.sex],
							orderDateString: item.orderDate + ' ' + ['', '上午', '下午'][item.amPmType]
						}, item);

						obj.houseTypeName = houseTypeMap[item.houseType];

						return obj;
					})
			},

			onSelectChange (selectedRowKeys) {
        console.log('selectedRowKeys changed: ', selectedRowKeys);
        this.selectedRowKeys = selectedRowKeys
			},

			handleClickActionBtn(item, id) {
				let signup = this.tableData.find(v => v.id == id);
				let self = this;
				console.log('signup', signup);

				 this.$confirm({
					title: '确定执行当前操作？',
					content: item.text + ' ' + signup.name + ' 的报名',
					okText: '确定',
					cancelText: '取消',
					onOk() {
						// console.log('OK');
						self.fetchModifyStatus({ studentSignupId: id, status: item.status,action:item });
					},
					onCancel() {
						console.log('Cancel');
					}
				});
			},

      async handleClickSuccessDownBtn(id) {
			  console.log('-> handleClickSuccessDownBtn', id);
        const hide = this.$message.loading('处理中..', 0);
        // 下载报名通知单 #李茹钰/2019-04-23#
        let { data } = await this.$ajax.gateway('/bm/IStudentSignupApi_downloadSignup', {
          studentSignupId: id
        });

        try {
          if (typeof hide !== 'undefined') hide();
        } catch (e) {
          console.log('-> catch e', e);
        }
        if (data && data.code == 200 && typeof data.data === 'object') {
          console.log('[-> SchoolDetail] 下载报名通知单成功', data);
          window.open(data.data.ossFileUrl, '_blank')
        } else {
          this.$message.error('下载申请表出错！');
        }
      },

			async fetchModifyStatus({ studentSignupId, status,action }) {

        if(action.action==='delete'){
          // 删除报名记录 #李茹钰/2019-04-24#
          let {data,error} = await this.$ajax.gateway("/bm/IStudentSignupApi_deleteSignup", {
            "body": [studentSignupId-0]
          });
          if(!data.data) return this.$message.error('删除失败！请稍后再试！');
          this.$message.success('删除成功！');
          this.onClickSearch();
          console.log(data,error);
          return;
        }

				// 修改报名状态 #李茹钰/2019-03-14#
				let { data, error } = await this.$ajax.gateway('/bm/IStudentSignupApi_auditStatus', {
					studentSignupId,
					status
				});

				if (error) {
					return false;
				}

				if (data.code === 200) {
					this.$message.success('更改报名状态成功！');
					this.onClickSearch()
				} else {
					this.$message.error('更改报名状态失败：' + data.message);
				}
			}
    }
  };
</script>

<style lang="stylus" scoped>
</style>
